export default __webpack_public_path__ + "static/media/DevelopmentBoardsImg.82c598ac.jpg";